import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { getIntDictOptions, DICT_TYPE } from '@/utils/dict';
import { KnowledgeApi } from '@/api/ai/knowledge/knowledge';
import { CommonStatusEnum } from '@/utils/constants';
import { ModelApi } from '@/api/ai/model/model';
import { AiModelTypeEnum } from '../../utils/constants';
import { reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
/** AI 知识库表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'KnowledgeForm'
  },
  __name: 'KnowledgeForm',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formType = ref(''); // 表单的类型：create - 新增；update - 修改
    const formData = ref({
      id: undefined,
      name: undefined,
      description: undefined,
      embeddingModelId: undefined,
      topK: undefined,
      similarityThreshold: undefined,
      status: CommonStatusEnum.ENABLE // 默认开启
    });
    const formRules = reactive({
      name: [{
        required: true,
        message: '请输入知识库名称',
        trigger: 'blur'
      }],
      embeddingModelId: [{
        required: true,
        message: '请输入向量模型',
        trigger: 'blur'
      }],
      topK: [{
        required: true,
        message: '请输入检索 topK',
        trigger: 'blur'
      }],
      similarityThreshold: [{
        required: true,
        message: '请输入检索相似度阈值',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '请选择是否启用',
        trigger: 'blur'
      }]
    });
    const formRef = ref(); // 表单 Ref
    const modelList = ref([]); // 向量模型选项
    /** 打开弹窗 */
    const open = async (type, id) => {
      dialogVisible.value = true;
      dialogTitle.value = '操作知识库';
      formType.value = type;
      resetForm();
      // 获取向量模型列表
      modelList.value = await ModelApi.getModelSimpleList(AiModelTypeEnum.EMBEDDING);
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          formData.value = await KnowledgeApi.getKnowledge(id);
        } finally {
          formLoading.value = false;
        }
      }
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        if (formType.value === 'create') {
          await KnowledgeApi.createKnowledge(data);
          message.success('创建成功');
        } else {
          await KnowledgeApi.updateKnowledge(data);
          message.success('修改成功');
        }
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        name: undefined,
        description: undefined,
        embeddingModelId: undefined,
        topK: undefined,
        similarityThreshold: undefined,
        status: CommonStatusEnum.ENABLE // 默认开启
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "130px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "知识库名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入知识库名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "知识库描述",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.description = $event),
              type: "textarea",
              rows: 3,
              placeholder: "请输入知识库描述"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "向量模型",
            prop: "embeddingModelId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.embeddingModelId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.embeddingModelId = $event),
              placeholder: "请选择向量模型",
              clearable: "",
              class: "!w-full"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "检索 topK",
            prop: "topK"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.topK,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.topK = $event),
              placeholder: "请输入检索 topK",
              min: 0,
              max: 10,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "检索相似度阈值",
            prop: "similarityThreshold"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.similarityThreshold,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.similarityThreshold = $event),
              placeholder: "请输入检索相似度阈值",
              min: 0,
              max: 1,
              step: 0.01,
              precision: 2,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.status = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: dict.value,
                  label: dict.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});